interface NavPathParams {
  pathDestination?: string;
  page?: string;
  uid?: string;
  view?: string;
}

export const constructNavPath = ({ pathDestination, page, uid, view }: NavPathParams): string => {
  if (pathDestination) return pathDestination;

  let path = '/app';
  if (page) path += `/${page}`;
  if (uid) path += `/${uid}`;
  if (view) path += `/${view}`;
  return path;
};
